import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });
export { client };

export const api = {
  me: () => client.get("/auth/me").then((r) => r.data),
  createSession: (session_id) => client.post("/auth/session", { session_id }).then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),

  listAllowedEmails: () => client.get("/admin/allowed-emails").then((r) => r.data),
  addAllowedEmail: (data) => client.post("/admin/allowed-emails", data).then((r) => r.data),
  removeAllowedEmail: (email) =>
    client.delete(`/admin/allowed-emails/${encodeURIComponent(email)}`).then((r) => r.data),
  listCategories: () => client.get("/categories").then((r) => r.data),
  createCategory: (data) => client.post("/categories", data).then((r) => r.data),
  deleteCategory: (id) => client.delete(`/categories/${id}`).then((r) => r.data),

  listTemplates: () => client.get("/templates").then((r) => r.data),
  createTemplate: (data) => client.post("/templates", data).then((r) => r.data),
  updateTemplate: (id, data) => client.put(`/templates/${id}`, data).then((r) => r.data),
  deleteTemplate: (id) => client.delete(`/templates/${id}`).then((r) => r.data),
  templateFromVersion: (planId, num, data) =>
    client.post(`/plans/${planId}/versions/${num}/to-template`, data).then((r) => r.data),

  listPlans: () => client.get("/plans").then((r) => r.data),
  createPlan: (data) => client.post("/plans", data).then((r) => r.data),
  getPlan: (id) => client.get(`/plans/${id}`).then((r) => r.data),
  deletePlan: (id) => client.delete(`/plans/${id}`).then((r) => r.data),

  listVersions: (planId) => client.get(`/plans/${planId}/versions`).then((r) => r.data),
  getVersion: (planId, num) => client.get(`/plans/${planId}/versions/${num}`).then((r) => r.data),
  createVersion: (planId, data) =>
    client.post(`/plans/${planId}/versions`, data).then((r) => r.data),
  setCurrentVersion: (planId, num) =>
    client.post(`/plans/${planId}/set-current/${num}`).then((r) => r.data),

  compareVersions: (planId, v1, v2) =>
    client.get(`/plans/${planId}/compare`, { params: { v1, v2 } }).then((r) => r.data),

  exportUrl: (planId, versionNum, format) =>
    `${API}/plans/${planId}/versions/${versionNum}/export?format=${format}`,
};

export const MONTHS_ES = [
  "", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
];

export const formatMoney = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(n);
};

export const formatPct = (n) => {
  if (n === null || n === undefined) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
};
